export const uxDesignerWorkEnvironment = {
  macos: {
    junior: [
      'Install Figma Desktop',
      'Setup Adobe Creative Cloud', 
      'Configure macOS for Design',
      'Install Sketch',
      'Setup Color Profiles'
    ],
    mid: [
      'Advanced Figma Setup',
      'Plugin Management',
      'Workflow Automation',
      'Advanced Color Management',
      'Typography Management'
    ],
    senior: [
      'Team Template Setup',
      'Design System Management',
      'Advanced Prototyping Setup',
      'Collaboration Tools',
      'Presentation Tools'
    ]
  },
  windows: {
    junior: [
      'Install Figma Desktop',
      'Setup Adobe Creative Cloud',
      'Configure Windows for Design',
      'Install Design Tools',
      'Setup Display Profiles'
    ],
    mid: [
      'Advanced Design Setup',
      'Workflow Optimization',
      'Cross-platform Compatibility',
      'Advanced Typography',
      'Plugin Management'
    ],
    senior: [
      'Team Management Tools',
      'Design System Setup',
      'Advanced Workflows',
      'Presentation Setup',
      'Collaboration Platforms'
    ]
  },
  linux: {
    junior: [
      'Web-based Figma Setup',
      'GIMP/Inkscape Installation',
      'Configure Linux for Design',
      'Color Management',
      'Font Installation'
    ],
    mid: [
      'Advanced FOSS Tools',
      'Workflow Optimization',
      'Cross-platform Design',
      'Typography Management',
      'Collaboration Setup'
    ],
    senior: [
      'Team Tool Management',
      'Open Source Design Systems',
      'Advanced Linux Workflows',
      'Presentation Tools',
      'Remote Collaboration'
    ]
  }
};
